import { createFileRoute } from '@tanstack/react-router';
import { Reporting } from '@/features/insights/Reporting';

export const Route = createFileRoute('/_app/reporting')({ component: Reporting });
